import { GetterTree, MutationTree } from 'vuex';
import { RootState, DropdownList, TPayload } from '@/types';
import actions from './audienceActions';
import { clone, assoc } from 'ramda';
import {
  Audience,
  AudienceState,
  Pixel,
  AudienceStatistics,
  ESource,
} from '@/types/audience/audience';

const audienceInit: Audience = {
  name: '',
  source: ESource.VISITORS,
  pixelIds: [],
  siteTimeId: null,
  fromDate: '',
  toDate: '',
  fileName: '',
  fileData: null,
  errors: {
    name: [],
    pixelIds: [],
    fileData: [],
  },
};

const state: AudienceState = {
  audience: clone(audienceInit),
  audiencesList: {
    paginationData: null,
    data: [] as Array<AudienceStatistics>,
  },
  pixels: [],
  siteTimes: {
    paginationData: null,
    data: [] as Array<DropdownList>,
  },
  isSavingForm: false,
};

const mutations: MutationTree<AudienceState> = {
  // ADD
  setAudience(state, audience: Audience): void {
    state.audience = audience;
  },
  setAudiencesList(state, data): void {
    if (!data.paginationData || !data.paginationData?.currentPage) {
      return;
    }
    state.audiencesList.paginationData = data.paginationData;
    state.audiencesList.data = data.data;
  },
  setPixel(state, data: Array<Pixel> = []): void {
    state.pixels = data;
  },
  setSiteTimes(state, data): void {
    if (!data.paginationData || !data.paginationData?.currentPage) {
      return;
    }
    state.siteTimes.paginationData = data.paginationData;
    state.siteTimes.data = data.data;
  },

  // UPDATE
  updateAudience(state, { name, value }: TPayload): void {
    state.audience = assoc(name, value)(state.audience);
  },
  updatePixel(state, data: Pixel): void {
    if (!data) return;
    state.pixels.push(data);
  },
  changeIsSavingForm(state, value: boolean): void {
    state.isSavingForm = value;
  },

  // DELETE
  deleteAudience(state, id: number): void {
    state.audiencesList.data = state.audiencesList.data.filter(item => {
      return item.id != id;
    });
  },
  deletePixel(state, id: number): void {
    state.pixels = state.pixels.filter((item: Pixel) => item.id !== id);
  },
  clearAudience(state): void {
    state.audience = clone(audienceInit);
  },
};

const getters: GetterTree<AudienceState, RootState> = {
  getAudience(state) {
    return state.audience;
  },
  getAudienceInit(): Audience {
    return audienceInit;
  },
  getAudiencesList(state) {
    return state.audiencesList.data.map((audience: Audience) => audience);
  },
  getAudiencePaginationData(state) {
    return state.audiencesList.paginationData;
  },
  getPixels(state) {
    return state.pixels.map((pixel: Pixel) => {
      return {
        label: pixel.name,
        value: pixel.id,
      };
    });
  },
  getSiteTimes(state) {
    return state.siteTimes.data.map(siteTime => {
      return {
        label: siteTime.label,
        value: siteTime.id,
      };
    });
  },
  getIsSavingForm(state): boolean {
    return state.isSavingForm;
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
};
